import { render, staticRenderFns } from "./InformherItems.vue?vue&type=template&id=1efc58be&scoped=true&"
import script from "./InformherItems.vue?vue&type=script&lang=js&"
export * from "./InformherItems.vue?vue&type=script&lang=js&"
import style0 from "./InformherItems.vue?vue&type=style&index=0&id=1efc58be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efc58be",
  null
  
)

export default component.exports